<style lang="stylus">
    .RenameTable-mask
        modal-mask()
        .RenameTable-modal
            width 378px
            height 180px
            .RenameTable-container
                padding 20px 0
                .RenameTable-line
                    display flex
                    justify-content space-around
                    >p
                        line-height 24px
</style>

<template>
    <div class="RenameTable-mask">
        <Dialog class="RenameTable-modal" :title="$t('title')" :isShow="true" @close="closeModal">
            <div class="RenameTable-container">
                <div class="RenameTable-line">
                    <p>{{ $t("newName") }}:</p>
                    <Input ref="renameInput" :maxlength="32" v-model="tableName" size="small" style="width: 260px" />
                </div>
            </div>

            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import Dialog from "../Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class RenameTable extends Vue {
        @Inject()
        ["showMessage"];
        oldtableName: string = "";
        tableName: string = "";
        DbName: string = "myDB";
        copyData: Array<object> = [];
        tableID: number = -1;
        userWorkerURL: string = appConfig.userWorkerURL;
        worker: any;
        // store
        uploadStoreInfo() {
            // update table

            let dbName = this.dbAndTable[0]; // 刷新ui
            let tableName = this.tableName;
            let tableID = this.dbAndTable[2];

            let menu = this.$store.state.library.menuList; // 更新用户自定义库的表名
            let showList = this.$store.state.library.displayList;
            for (let i = 0; i < menu.length; i++) {
                if (menu[i].groupName == dbName) {
                    let children = menu[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].tableName == this.oldtableName) {
                            menu[i].children[j].tableName = tableName;
                        }
                    }
                }
            }
            for (let i = 0; i < showList.length; i++) {
                if (showList[i].groupName == dbName) {
                    let children = showList[i].children;
                    for (let j = 0; j < children.length; j++) {
                        if (children[j].tableName == this.oldtableName) {
                            showList[i].children[j].tableName = tableName;
                        }
                    }
                }
            }
            let ts: any = this;
            ts.$bus.$emit("setLibrary", {
                type: "updateLibrary",
                groupName: dbName,
                tableID: tableID,
            });

            this.$store.commit("setStatus", { type: "selectLibrary", data: [this.DbName, this.tableName, tableID] }); // 主要为了更新新的表名
        }
        confirm() {
            this.closeModal();
            if (this.tableName.trim() == "") {
                // this.showMessage({
                //     type: 2,
                //     imgType: 2,
                //     time: 1,
                //     content: this.$t("nullName")
                // })
                return;
            }

            if (this.tableName === "我的收藏") {
                this.showMessage({
                    type: 2,
                    imgType: 2,
                    time: 1,
                    content: this.$t("repeatedName"),
                });
                return;
            }
            let userInfo = this.$store.state.user.userInfo;
            this.worker = new Worker(this.userWorkerURL);
            this.worker.postMessage({
                type: "rename",
                urls: this.urls,
                data: {
                    DBName: this.DbName,
                    tableName: this.tableName,
                    oldTableName: this.oldtableName,
                    tableID: this.dbAndTable[2],
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                },
            });
            let repeatedRemind = {
                // 放在worker里不能使用$t翻译
                type: 2,
                imgType: 2,
                time: 1,
                content: this.$t("repeatedName"),
            };
            let ossList = this.$store.state.library.ossList;
            this.worker.onmessage = (e) => {
                let message = e.data;
                if (message.type === "renameOK") {
                    this.uploadStoreInfo();
                    this.sensors.track("libRename", {
                        Catalogues: "editFileProcess",
                    });

                    let updateID = -1;
                    let symbol_key = "";
                    for (let i = 0; i < ossList.length; i++) {
                        if (ossList[i].table_id == message.data.tableID) {
                            updateID = ossList[i].id;
                            symbol_key = ossList[i].symbol_key;
                            break;
                        }
                    }

                    if (updateID != -1) {
                        this.$edApi
                            .updateCustomLibrary({
                                id: userInfo.user_id,
                                token: userInfo.token,
                                lid: updateID,
                                name: this.tableName,
                                version: message.data.version,
                                tableID: message.data.tableID,
                                symbol_key,
                            })
                            .then((e) => {
                                let version = e.data.version;
                                this.worker.postMessage({
                                    type: "setVersion",
                                    urls: this.urls,
                                    data: {
                                        versionDB: `myDBVersion_${userInfo.user_id}`,
                                        tableID: this.dbAndTable[2],
                                        version,
                                        params: {
                                            updateModified: false,
                                        },
                                    },
                                });
                                console.log("update table success");
                            });
                    }
                } else if (message.msg === "name repeated") {
                    this.showMessage(repeatedRemind);
                    this.worker.terminate();
                } else if (message.type === "setVersionOK") {
                    this.worker.terminate();
                }
            };
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        mounted() {
            this.$nextTick(() => {
                //自动获取焦点 element组件autofocus失效
                (this.$refs["renameInput"] as any).$refs.input.focus();
            });
        }
        get dbAndTable() {
            return this.$store.state.ui.selectLibrary;
        }
        created() {
            this.oldtableName = this.dbAndTable[1];
            this.DbName = this.$store.state.library.extraDB[2];
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "重命名库",
    "newName": "新名称",
    "confirm": "确定",
    "cancel": "取消",
    "nullName": "库名不可为空",
    "repeatedName": "库名不可重复"
  },
  "en": {
    "title": "Rename Library",
    "newName": "New Name",
    "confirm": "OK",
    "cancel": "Cancel",
    "nullName": "Library Name cannot be empty.",
    "repeatedName": "Library Name cannot be repeated."
  },
  "fr": {
    "title": "Renommer la Bibliothèque",
    "newName": "Nouveau Nom",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "nullName": "Nom de la bibliothèque ne peut pas être vide",
    "repeatedName": "Nom de la bibliothèque ne peut pas être dupliqué"
  },
  "de": {
    "title": "Bibliothek umbenennen",
    "newName": "Neuer Name",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "nullName": "Bibliothekname darf nicht leer sein",
    "repeatedName": "Bibliothekname darf nicht wiederholt werden"
  },
  "jp": {
    "title": "ライブラリ名を変更",
    "newName": "新しい名",
    "confirm": "OK",
    "cancel": "キャンセル",
    "nullName": "ライブラリ名は空にできません",
    "repeatedName": "ライブラリ名は重複できません"
  },
  "es": {
    "title": "Renombrar la biblioteca",
    "newName": "Nuevo nombre",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "nullName": "Nombre de la biblioteca no puede estar vacío",
    "repeatedName": "El nombre de la biblioteca no puede ser repetido"
  },
  "pt": {
    "title": "Renomear Biblioteca",
    "newName": "Novo Nome",
    "confirm": "OK",
    "cancel": "Cancelar",
    "nullName": "Nome de Biblioteca não pode estar vazia.",
    "repeatedName": "Nome de Biblioteca não pode ser repetido."
  },
  "it": {
    "title": "Rinomina Libreria",
    "newName": "Nuovo Nome",
    "confirm": "OK",
    "cancel": "Annulla",
    "nullName": "Si prega di selezionare un nome per la libreria.",
    "repeatedName": "Il nome selezionato è già esistente. Si prega di sceglierne un altro."
  },
  "tw": {
    "title": "重命名庫",
    "newName": "新名稱",
    "confirm": "確定",
    "cancel": "取消",
    "nullName": "庫名不可為空",
    "repeatedName": "庫名不可重複"
  },
  "kr": {
    "title": "라이브러리 이름 변경",
    "newName": "새 이름",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "nullName": "라이브러리 이름은 비워 둘 수 없습니다",
    "repeatedName": "라이브러리 이름을 반복할 수 없습니다."
  }
}
</i18n>
